/**
 * Validates if a premise level pricing offer is within the valid date range
 * @param startDate - The start date string (optional)
 * @param endDate - The end date string (optional)
 * @returns boolean indicating if the current time is within the valid range
 */
export function isPremiseLevelPricingDateValid(startDate?: string, endDate?: string): boolean {
  const now = Date.now()
  
  // Check start date
  const startValid = !startDate || now >= new Date(startDate).getTime()
  
  // Check end date - set to end of day (23:59:59.999) to ensure offers are valid throughout the entire end date
  let endValid = true
  if (endDate) {
    const endDateTime = new Date(endDate)
    endDateTime.setHours(23, 59, 59, 999) // Set to end of day in local timezone
    endValid = now <= endDateTime.getTime()
  }
  
  return startValid && endValid
}
